export default {
	init() {
		const productForm = $('#product-form');
		const productSummary = $('#product-summary');
		const productSummaryPrice = $('#product-summary-price');
		const productSummaryTable = $('#product-summary-table');
		const mobileBarPrice = $('#mobile-bar-price');

		handleProductForm();
		productForm.change(handleProductForm);
		productForm.on('keyup keypress', function(e) {
			var keyCode = e.keyCode || e.which;
			if (keyCode === 13) {
				e.preventDefault();
				return false;
			}
		});

		let doingProductFormAjax = false;
		let productFormData = null;

		function handleProductForm() {
			productFormData = new FormData(productForm[0]);
			handleCaseDeluxe(productFormData);
			doProductFormAjax();
		}

		function doProductFormAjax(){

			if(productFormData === null || doingProductFormAjax) return;

			var addToCartBtn = $('#add-to-cart');


			var formData = productFormData;
			formData.append('action','kampa_product_calculation');

			productFormData = null;
			doingProductFormAjax = true;

			productSummary.addClass('loading');
			addToCartBtn.attr('disabled',true);

			$.ajax({
				type: 'POST',
				url: kampa.ajax_url,
				data: formData,
				processData: false,
				contentType: false,
				success: function (res) {
					let data = JSON.parse(res);

					doingProductFormAjax = false;
					doProductFormAjax();

					productSummaryPrice.html(data.price_html);
					mobileBarPrice.html(data.price_html);
					productSummary.removeClass('loading');

					if(data.configurations.length){
						productSummaryTable.html('');

						data.configurations.forEach(function(e) {
							productSummaryTable.append('<tr><td><a href="#'+e.key+'">'+e.label+'</a></small></td><td class="w-50">'+e.value_html+'</td></tr>');
						});
					}

					$('.warning').html('');
					$('.field-warning').removeClass('field-warning');
					if(!data.validation.result){
						data.validation.warnings.forEach(function(e){
							let warningEl = $('#warning-' + e.key);
							warningEl.html(e.msg);
							$('#' + warningEl.data('field')).addClass('field-warning');

						});
					}
					else {
						addToCartBtn.attr('disabled',false);
					}
				},
			});
		}

		handleColorChange();
		$('.color-input').change(handleColorChange);
		function handleColorChange(){
			let checked = $('.color-input:checked');
			let src = checked.data('img');
			$('#configurator-color-image').attr('src',src);
		}

		handleClosures();
		$('#closure').change(handleClosures);
		function handleClosures(){
			let closure = $('#closure').val();
			let closureType = $('#closure_type');
			if(closure != 'none'){
				closureType.show();
			}
			else closureType.hide();
		}

		this.curtainScripts();

		handleFabricsSwitch();
		$('.fabric-switch__input').change(handleFabricsSwitch);
		function handleFabricsSwitch(){
			let checked = $('.fabric-switch__input:checked');
			let fabric = checked.data('fabric');
			let wrapper = $('.colors-wrapper#colors-fabric_'+fabric);
			$('.colors-wrapper').removeClass('active');
			wrapper.addClass('active');

			if(wrapper.find('.color-input:checked').length === 0){
				let colorField = wrapper.find('.color-input').first()
				colorField.prop('checked',true);
				colorField.trigger('change');
			}
		}

		handleSunsailSideKeder();
		$('#side_keder').change(handleSunsailSideKeder);
		function handleSunsailSideKeder(){
			let sideKederRailRow = $('#side-keder-rail-row');
			let sideKeder = $('#side_keder').val();

			$('.extra-brackets-field').attr('disabled',false);

			if(sideKeder != 'none'){
				sideKederRailRow.show();

				$('#extra_bracket_'+sideKeder).attr('disabled',true);
			}
			else{
				sideKederRailRow.hide();
			}
		}

		/**
		 * Case deluxe
		 */
		function handleCaseDeluxe(formData){
			let rubberCord = $('#extras_rubber_cord');
			$('#case-options').show();
			rubberCord.show();

			if(formData.get('rubber_band')){
				$('#case-options').hide();
				rubberCord.hide();
			}
		}

		/**
		 * Extra products
		 */
		$('.extra-product__button').click(function(e){
			e.preventDefault();
			let productID = $(this).data('product');
			let parent = $(this).parents('.extra-product');
			let quantity = parseInt(parent.find('.extra-product__quantity').val());

			parent.addClass('loading');

			$.ajax({
				type: 'POST',
				url: kampa.ajax_url,
				data: {
					action : 'kampa_extra_product_add_to_cart',
					product_id : productID,
					quantity : quantity,
				},
				success: function (res) {
					parent.removeClass('loading');

					if(res){
						parent.addClass('added');

						setTimeout(function(){
							parent.removeClass('added');
						}, 3000);
					}
				},
			});
		});
	},
	curtainScripts() {

		handleCurtainExtras();
		$('input[name="edges[top]"]').change(handleCurtainExtras);
		function handleCurtainExtras(){
			let edgeTop = $('input[name="edges[top]"]:checked').val();
			$('.curtain-extras-col').hide();

			if(edgeTop == '30_circle' || edgeTop == '50_circle'){
				$('#steel_rope_col').show();
				$('#rail_col').find('input').removeAttr('checked');
			}
			else{
				$('#rail_col').show();
				$('#steel_rope_col').find('input').removeAttr('checked');
			}

			handleRailSelect();
		}

		handleRailSelect();
		$('#rail_col input').change(handleRailSelect)
		function handleRailSelect(){
			if($('#rail_col input').prop('checked')){
				$('#holders').show();
			}
			else $('#holders').hide();
		}
	},
};



// WEBPACK FOOTER //
// ./scripts/routes/singleProduct.js